'use strict';
bankReconciliationController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'reportHelper',
	'bankReconLogService',
	'bankService',
	'outstandingCheckService',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('bankReconciliationController', bankReconciliationController);

function bankReconciliationController(
	$scope,
	$rootScope,
	$q,
	$interval,
	reportHelper,
	bankReconLogService,
	bankService,
	outstandingCheckService,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadBanks($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			banks: [],
			calendarYears: [],
			report: {
				reportType: 'OutstandingItems',
				bank: null,
				calendarYear: 0,
				statementDT: moment().toDate(),
				showSavedClearedItems: false,
				clearedItemsReportType: 'ProcessedAndSaved',
				fromDT: moment().startOf('month').toDate(),
				toDT: moment()
					.startOf('month')
					.add(moment().daysInMonth() - 1, 'd')
					.toDate(),
			},
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.report.reportType === 'ReconLogs') {
				if (!model.report.bank.selectedLog) {
					model.validationErrors.push('No reconciliation summary has been selected.');
					isValid = false;
				}
			} else if (model.report.fromDT > model.report.toDT) {
				model.validationErrors.push('From Date cannot be after the To Date.');
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				ReportType: model.report.reportType,
				BankId: model.report.bank.Id,
				BankName: model.report.bank.DisplayName,
				StatementDT: model.report.statementDT,
				ShowSavedClearedItems: model.report.showSavedClearedItems,
				ClearedItemsReportType: model.report.clearedItemsReportType,
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				BankReconLogId: model.report.bank.selectedLog ? model.report.bank.selectedLog.Id : null,
			};

			reportHelper.getReport($scope, '/api/fundreports/bankreconciliationreport', report, 'BankReconciliationReport.pdf');
		}

		function loadCalendarYears(model) {
			let bankId = model.report.bank ? model.report.bank.Id : 0;
			return outstandingCheckService.getCalendarYears(bankId).then(_.partial(finishLoadingYears, model));

			function finishLoadingYears(model, response) {
				model.calendarYears = response.data.calendarYears;
				model.calendarYears[0] ? (model.report.calendarYear = model.calendarYears[0]) : 0;
				if (model.calendarYears.length === 0) {
					model.calendarYears.push(2017);
				}
				model.report.calendarYear = model.calendarYears[0];
				loadStatementDates(model);
				return angular.noop;
			}
		}

		function loadStatementDates(model) {
			let bankId = model.report.bank ? model.report.bank.Id : 0;
			return outstandingCheckService.getClearDates(bankId, model.report.calendarYear).then(_.partial(finishLoadingClearDates, model));

			function finishLoadingClearDates(model, response) {
				model.clearDates = response.data.clearDates;
				if (model.clearDates.length === 0) {
					model.clearDates.push(moment().format('MM/DD/YYYY'));
				}
				model.report.statementDT = model.clearDates[0];

				return angular.noop;
			}
		}

		function loadBanks(model) {
			return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				if (model.banks[0]) {
					model.report.bank = model.banks[0];
				}
				return angular.noop;
			}
		}

		function loadReconLogsForBank(model, bank) {
			model.errors = null;

			if (model.report.reportType !== 'ReconLogs') return;
			if (bank.logs) return;

			bankReconLogService.getByBankId(bank.Id).then(_.partial(finishGettingBankLogs, model));

			function finishGettingBankLogs(model, response) {
				if (response.data.isValid) {
					bank.logs = response.data.bankLogs;
				} else {
					model.errors = response.data.errors;
				}
				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadBanks: _.partial(loadBanks, model),
			loadCalendarYears: _.partial(loadCalendarYears, model),
			loadStatementDates: _.partial(loadStatementDates, model),
			openReport: _.partial(openReport, model),
			loadReconLogsForBank: _.partial(loadReconLogsForBank, model),
		});
	}
}
